import React from 'react'
import "../css/main1.css"

function Section1() {
  return (
    <div className='section01' id ="HOME">
       {/* <div className='innerContainer'>
        <small>안녕하세요. 웹 개발자</small>
        <div className='pc textAniContainer'>
                <div className='text'>
                    <h1>김민주입니다.</h1>
                    <h1>끊임없이 <span>도전</span>을 즐기며</h1>
                    <h1>한계를 넘어 <span>성장</span>을 향해 달려가고 있습니다.</h1>
                </div>
                <div className='substance'>
                    <h1>김민주입니다.</h1>
                    <h1>끊임없이 <span>도전</span>을 즐기며</h1>
                    <h1>한계를 넘어 <span>성장</span>을 향해 달려가고 있습니다.</h1>
                </div>
        </div>
        <div className='mo textAniContainer'>
                <div className='text'>
                    <h1>김민주입니다.</h1>
                    <h1>끊임없이 <span>도전</span>을</h1>
                    <h1>즐기며한계를 넘어</h1>
                    <h1><span>성장</span>을 향해 달려가고</h1>
                    <h1>있습니다.</h1>
                </div>
                <div className='substance'>
                    <h1>김민주입니다.</h1>
                    <h1>끊임없이 <span>도전</span>을</h1>
                    <h1>즐기며한계를 넘어</h1>
                    <h1><span>성장</span>을 향해 달려가고</h1>
                    <h1>있습니다.</h1>
                </div>
                
        </div>
       </div> */}
    </div>
  )
}

export default Section1